'use strict';

wbApp.factory('messagesSvc', ['$resource', '$http', '$q', '$translate', 'notificationSvc', 'repositorySvc',
    function ($resource, $http, $q, $translate, notificationSvc, repositorySvc) {

        var SmsHistory = $resource('/Api/Messages/:id', {}, {
            'getSmsHistoryByDateRange': { method: 'GET', isArray: true, url: '/Api/Messages/GetSmsHistoryByDateRange' },
        });

        function sendEmail(recipientList, subject, messageBody, attachments) {
            var deferred = $q.defer();

            $http({
                method: 'POST',
                url: 'Api/Messages/SendEmail',
                data: {
                    recipients: recipientList,
                    subject: subject,
                    messageBody: messageBody,
                    attachments: attachments
                }
            })
            .success(function (data, status, headers, config) {
                deferred.resolve(data);
                notificationSvc.notifyInfo(
                    $translate.instant('TXT_ALERT_TITLE_EMAIL_SEND_SUCCESS'));
            })
            .error(function (data, status, headers, config) {
                deferred.reject(data);
                notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_TITLE_EMAIL_SEND_FAILURE'),
                    notificationSvc.translateError(data));
            });

            return deferred.promise;
        }

        function sendSms(recipientList, smsText) {
            var deferred = $q.defer();

            $http({
                method: 'POST',
                url: 'Api/Messages/SendSms',
                data: {
                    recipients: recipientList,
                    messageBody: smsText
                }
            })
            .success(function (data, status, headers, config) {
                deferred.resolve(data);
                notificationSvc.notifyInfo(
                    $translate.instant('TXT_ALERT_TITLE_SEND_SEND_SUCCESS'));
            })
            .error(function (data, status, headers, config) {
                deferred.reject(data);
                notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_TITLE_SMS_SEND_FAILURE'),
                    notificationSvc.translateError(data));
            });

            return deferred.promise;
        }

        function getSmsHistoryByDateRage(fromDate, toDate) {
            return repositorySvc.customGet(
                'getSmsHistoryByDateRange',
                SmsHistory,
                {
                    fromDate: moment(fromDate).toJSON(),
                    toDate: moment(toDate).toJSON()
                });
        }

        return {
            sendEmail: sendEmail,
            sendSms: sendSms,
            getSmsHistoryByDateRage: getSmsHistoryByDateRage
        };
    }
]);